import { render } from "./SendNotification.vue?vue&type=template&id=4c1b3f74&scoped=true"
const script = {}

import "./SendNotification.vue?vue&type=style&index=0&id=4c1b3f74&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1b3f74"]])

export default __exports__